export default __webpack_public_path__ + "static/media/8.754d2b57.png";